<template>
  <OmtGrid>
    <OmtRow
      :desktopStart="3"
      :desktopEnd="10"
      :min-height="['calc(100vh - 266px)', 'calc(100vh - 500px)']"
    >
      <CBox v-if="titulo && texto">
        <OmtTypography
          as="h1-bold"
          mb="24px"
        >
          <span
            data-cy="terms-title"
            v-html="titulo"
          />
        </OmtTypography>

        <OmtTypography
          mb="16px"
          as="p1"
        >
          <span
            data-cy="terms-text"
            v-html="texto"
          />
        </OmtTypography>
      </CBox>
      <CFlex
        v-else
        align-items="center"
        justify-content="center"
      >
        Carregando...
      </CFlex>
    </OmtRow>
    <OmtRow
      mt="16px"
      :desktopStart="4"
      :desktopEnd="9"
    >
      <CStack :align="['flex-start', 'center']">
        <OmtButton
          w="100%"
          mb="24px"
          :disabled="!titulo || !texto"
          @click="openInfoModal"
        >
          Concordar e continuar
        </OmtButton>
      </CStack>
    </OmtRow>

    <RefundCreateTermsModal
      :isOpen.sync="modalIsOpen"
      @continue="onContinue"
    />
  </OmtGrid>
</template>

<script>
import RefundCreateTermsModal from "@/components/Organisms/RefundNew/RefundCreateTermsModal.vue";
import { mapActions, mapState } from "vuex";

export default {
  components: {
    RefundCreateTermsModal
  },
  data() {
    return {
      modalIsOpen: false
    };
  },
  computed: {
    ...mapState("refund", ["addPermission", "terms", "newRefund"]),
    titulo() {
      return this.terms ? this.terms.ds_TituloTermoAceite : "";
    },
    texto() {
      return this.terms ? this.terms.ds_TextoTermoAceite : "";
    }
  },
  async mounted() {
    if (!this.newRefund || this.newRefund.type === null) {
      this.$router.push({ name: "refund.new.create" });
      return;
    }
    if (await this.getIsRefundOdontologico()) {
      this.$root.$emit("change-back-route", "/refund-new");
    } else {
      this.$root.$emit("change-back-route", "/refund-new/create");
    }
    try {
      await this.$root.$emit("show-loading");
      if (!this.addPermission) {
        await this.fetchAddPermission();
      }
      if (this.addPermission) {
        await this.fetchTerms();
      } else {
        this.$router.push({ name: "refund.new" });
        return;
      }
    } finally {
      await this.$root.$emit("hide-loading");
    }
  },
  methods: {
    ...mapActions("refund", ["fetchAddPermission", "fetchTerms", "getIsRefundOdontologico"]),
    onContinue() {
      this.$router.push({
        name: "refund.new.create.check"
      });
    },
    openInfoModal() {
      this.modalIsOpen = true;
    }
  }
};
</script>
